import React, { useState } from "react";
import { 
    ArrowLeftIcon, 
    PlusIcon, 
    TrashIcon, 
    TargetIcon, 
    DocumentChartBarIcon,
    ExclamationCircleIcon 
} from "@heroicons/react/24/outline";

const AppraisalSetup = () => {
  const [selectedEmp, setSelectedEmp] = useState("");
  const [kpis, setKpis] = useState([
    { id: 1, title: "Code Quality", weight: 40, target: "Maintain < 2% bug rate", note: "Focus on unit test coverage." }
  ]);

  const addKPI = () => setKpis([...kpis, { id: Date.now(), title: "", weight: 0, target: "", note: "" }]);
  const removeKPI = (id) => setKpis(kpis.filter(k => k.id !== id));
  
  const totalWeight = kpis.reduce((acc, curr) => acc + Number(curr.weight), 0);

  return (
    <div className="p-4 md:p-8 bg-[#f8fafc] min-h-screen font-roboto">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Roboto:wght@400;500;700&display=swap');
        .font-poppins { font-family: 'Poppins', sans-serif; }
      `}</style>

      <div className="max-w-4xl mx-auto">
        <button className="flex items-center gap-2 text-slate-400 mb-6 hover:text-indigo-600 transition-all font-bold text-xs uppercase tracking-widest">
          <ArrowLeftIcon className="h-4 w-4" /> Back to Dashboard
        </button>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          <div className="p-8 border-b border-slate-100 bg-slate-50/50">
            <div className="flex justify-between items-start">
                <div>
                    <h2 className="text-2xl font-poppins font-bold text-slate-900">Assign Project Goals</h2>
                    <p className="text-sm text-slate-500 mt-1">Step 2: Set expectations for the upcoming performance cycle.</p>
                </div>
                <div className={`px-4 py-2 rounded-xl border font-bold text-xs ${totalWeight === 100 ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-amber-50 text-amber-600 border-amber-100'}`}>
                    Total Weight: {totalWeight}%
                </div>
            </div>
          </div>

          <div className="p-8 space-y-8">
            <div className="max-w-md">
              <label className="block text-[10px] font-black text-slate-400 uppercase mb-2 tracking-widest">Target Employee</label>
              <select 
                className="w-full p-3 bg-white border border-slate-200 rounded-xl text-sm outline-none focus:ring-4 focus:ring-indigo-500/5 focus:border-indigo-500 transition-all"
                value={selectedEmp}
                onChange={(e) => setSelectedEmp(e.target.value)}
              >
                <option value="">Search employee database...</option>
                <option value="EMP-099">Johnathan Doe (Lead Dev)</option>
                <option value="EMP-101">Arjun Mehta (Senior UI/UX)</option>
              </select>
            </div>

            <div className="space-y-4">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Key Performance Indicators</label>
              
              {kpis.map((kpi, index) => (
                <div key={kpi.id} className="group relative p-6 bg-slate-50/50 rounded-2xl border border-slate-200 hover:border-indigo-200 transition-all">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <div className="md:col-span-3 space-y-4">
                      <input 
                        placeholder="KPI Title (e.g., System Architecture)" 
                        className="w-full bg-transparent font-bold text-slate-800 border-b border-slate-200 pb-2 outline-none focus:border-indigo-500"
                        value={kpi.title}
                      />
                      <input 
                        placeholder="Measurable Target (e.g., 99.9% Uptime)" 
                        className="w-full bg-transparent text-sm text-slate-600 border-b border-slate-100 pb-2 outline-none focus:border-indigo-400"
                        value={kpi.target}
                      />
                      <textarea 
                        placeholder="Guidance Notes for Employee..."
                        className="w-full bg-white border border-slate-200 rounded-lg p-3 text-xs outline-none focus:ring-2 focus:ring-indigo-500/10"
                        rows="1"
                      />
                    </div>
                    <div className="flex flex-col gap-4">
                        <div>
                            <label className="text-[9px] font-bold text-slate-400 uppercase">Weightage %</label>
                            <input 
                                type="number" 
                                value={kpi.weight}
                                className="w-full p-2.5 bg-white border border-slate-200 rounded-xl text-sm font-bold text-indigo-600"
                            />
                        </div>
                        <button onClick={() => removeKPI(kpi.id)} className="flex items-center justify-center gap-2 p-2.5 text-rose-500 hover:bg-rose-50 rounded-xl transition-all text-[10px] font-bold uppercase">
                            <TrashIcon className="h-4 w-4" /> Remove
                        </button>
                    </div>
                  </div>
                </div>
              ))}

              <button 
                onClick={addKPI}
                className="w-full py-4 border-2 border-dashed border-slate-200 rounded-2xl flex items-center justify-center gap-2 text-slate-400 hover:border-indigo-300 hover:text-indigo-600 transition-all font-bold text-xs uppercase"
              >
                <PlusIcon className="h-4 w-4" /> Add Metric
              </button>
            </div>
          </div>

          <div className="p-8 bg-slate-50 border-t border-slate-100 flex justify-end gap-4">
             <button className="px-8 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest hover:text-slate-700">Save Draft</button>
             <button className="px-10 py-3 text-[10px] font-black bg-slate-900 text-white rounded-xl uppercase tracking-widest shadow-xl shadow-slate-200 hover:bg-indigo-600 transition-all">Publish to Employee</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AppraisalSetup;